import React, { createContext, useState, useContext, useEffect } from 'react';

const ConfigContext = createContext();

export const useConfig = () => {
  return useContext(ConfigContext);
};

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    gameName: "JV Rummy",
    logoUrl: null, // Will be stored as base64 or URL
    logoFile: null,
    currencies: {
      USD: { symbol: '$', name: 'US Dollar' },
      LRD: { symbol: 'L$', name: 'Liberian Dollar' },
      INR: { symbol: '₹', name: 'Indian Rupee' }
    },
    welcomeBonus: {
      USD: 0,
      LRD: 500,
      INR: 0,
      practiceChips: 5000
    }
  });

  // Load config from localStorage on component mount
  useEffect(() => {
    const savedConfig = localStorage.getItem('rummyPlatformConfig');
    if (savedConfig) {
      try {
        setConfig(JSON.parse(savedConfig));
      } catch (error) {
        console.error('Error loading config:', error);
      }
    }
  }, []);

  // Save config to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('rummyPlatformConfig', JSON.stringify(config));
  }, [config]);

  // Update game name
  const updateGameName = (newName) => {
    setConfig(prev => ({
      ...prev,
      gameName: newName
    }));
  };

  // Handle logo upload
  const uploadLogo = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        setConfig(prev => ({
          ...prev,
          logoUrl: e.target.result,
          logoFile: file
        }));
        resolve(e.target.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  // Remove logo
  const removeLogo = () => {
    setConfig(prev => ({
      ...prev,
      logoUrl: null,
      logoFile: null
    }));
  };

  // Update welcome bonus amounts
  const updateWelcomeBonus = (newBonus) => {
    setConfig(prev => ({
      ...prev,
      welcomeBonus: { ...prev.welcomeBonus, ...newBonus }
    }));
  };

  const value = {
    config,
    updateGameName,
    uploadLogo,
    removeLogo,
    updateWelcomeBonus
  };

  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
};